import { TableCell, TableHead, TableRow, TableSortLabel } from '@dls/react-core';
import React from 'react';
import { makeStyles } from '@material-ui/core';

export const sortedTableStyles = makeStyles({
  root: {
    width: '100%',
  },
  paper: {
    width: '100%',
  },
  table: {
    minWidth: 650,
  },
  visuallyHidden: {
    border: 0,
    clip: 'rect(0 0 0 0)',
    height: 1,
    margin: -1,
    overflow: 'hidden',
    padding: 0,
    position: 'absolute',
    top: 20,
    width: 1,
  },
  checkbox: {
    display: 'flex',
  },
});

export type Order = 'asc' | 'desc';

interface EnhancedTableProps<T> {
  classes: ReturnType<typeof sortedTableStyles>;
  onRequestSort: (event: React.MouseEvent<unknown>, property: keyof T) => void;
  order: Order;
  orderBy: string;
  headCells: HeadCell<T>[];
}

export type HeadCell<T> =
  | {
      type: 'sortable';
      width?: number;
      disablePadding: boolean;
      id: keyof T;
      label: string;
      numeric: boolean;
    }
  | {
      type: 'other';
      width?: number;
      id: string;
      disablePadding: boolean;
      label: string;
    };

export function EnhancedTableHead<T>(props: EnhancedTableProps<T>) {
  const { classes, order, orderBy, onRequestSort, headCells } = props;
  const createSortHandler = (property: keyof T) => (event: React.MouseEvent<unknown>) => {
    onRequestSort(event, property);
  };

  return (
    <TableHead>
      <TableRow>
        {headCells.map((headCell, idx) => {
          return (
            <TableCell
              key={headCell.id.toString()}
              padding={headCell.disablePadding ? 'none' : 'default'}
              sortDirection={orderBy === headCell.id ? order : false}
              className={'sorting-header'}
              width={headCell.width}
            >
              {headCell.type === 'sortable' ? (
                <TableSortLabel
                  active={orderBy === headCell.id}
                  direction={orderBy === headCell.id ? order : 'asc'}
                  onClick={createSortHandler(headCell.id)}
                >
                  {headCell.label}
                  {orderBy === headCell.id ? (
                    <span className={classes.visuallyHidden}>
                      {order === 'desc' ? 'sorted descending' : 'sorted ascending'}
                    </span>
                  ) : null}
                </TableSortLabel>
              ) : (
                headCell.label
              )}
            </TableCell>
          );
        })}
      </TableRow>
    </TableHead>
  );
}
